export const InstagramIcon = ({ className }: { className: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      aria-label="Instagram"
    >
      <title>Instagram</title>
      {/* Gradient square background */}
      <defs>
        <linearGradient
          id="igGradient"
          x1="0%"
          y1="100%"
          x2="100%"
          y2="0%"
        >
          <stop
            offset="0%"
            stopColor="#f58529"
          />
          <stop
            offset="50%"
            stopColor="#dd2a7b"
          />
          <stop
            offset="100%"
            stopColor="#515bd4"
          />
        </linearGradient>
      </defs>
      <rect
        x="0"
        y="0"
        width="24"
        height="24"
        rx="4"
        fill="url(#igGradient)"
      />
      {/* White camera icon */}
      <path
        fill="#ffffff"
        d="M12 6.5c2.5 0 2.8 0 3.8.1.9 0 1.4.2 1.7.3.4.2.7.4 1 .7.3.3.5.6.7 1 .1.3.3.8.3 1.7.1 1 .1 1.3.1 3.8s0 2.8-.1 3.8c0 .9-.2 1.4-.3 1.7-.2.4-.4.7-.7 1-.3.3-.6.5-1 .7-.3.1-.8.3-1.7.3-1 .1-1.3.1-3.8.1s-2.8 0-3.8-.1c-.9 0-1.4-.2-1.7-.3-.4-.2-.7-.4-1-.7-.3-.3-.5-.6-.7-1-.1-.3-.3-.8-.3-1.7-.1-1-.1-1.3-.1-3.8s0-2.8.1-3.8c0-.9.2-1.4.3-1.7.2-.4.4-.7.7-1 .3-.3.6-.5 1-.7.3-.1.8-.3 1.7-.3 1-.1 1.3-.1 3.8-.1M12 5c-2.6 0-2.9 0-3.9.1-.9 0-1.6.2-2.1.4-.6.2-1.1.6-1.6 1.1-.5.5-.9 1-1.1 1.6-.2.5-.4 1.2-.4 2.1C3 11.4 3 11.7 3 14.3s0 2.9.1 3.9c0 .9.2 1.6.4 2.1.2.6.6 1.1 1.1 1.6.5.5 1 .9 1.6 1.1.5.2 1.2.4 2.1.4 1 .1 1.3.1 3.9.1s2.9 0 3.9-.1c.9 0 1.6-.2 2.1-.4.6-.2 1.1-.6 1.6-1.1.5-.5.9-1 1.1-1.6.2-.5.4-1.2.4-2.1.1-1 .1-1.3.1-3.9s0-2.9-.1-3.9c0-.9-.2-1.6-.4-2.1-.2-.6-.6-1.1-1.1-1.6-.5-.5-1-.9-1.6-1.1-.5-.2-1.2-.4-2.1-.4C14.9 5 14.6 5 12 5zm0 3.2c-2.7 0-4.8 2.1-4.8 4.8s2.1 4.8 4.8 4.8 4.8-2.1 4.8-4.8-2.1-4.8-4.8-4.8zm0 7.9c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1 3.1 1.4 3.1 3.1-1.4 3.1-3.1 3.1zm6.2-8.1c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2 1.2-.5 1.2-1.2-.5-1.2-1.2-1.2z"
      />
    </svg>
  );
};
